// frontend/src/components/concierge/tabs/ListsCard.jsx
// Overview "Lists" card: every list (Lists page) this athlete is on, newest
// first, with when it was last sent, to how many coaches, and how many opened
// it. The server scopes partners to their own lists. Adding the athlete to a
// list or sending one stamps Last managed server-side (reports.py).
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { fmtMonDay } from '../../../lib/conciergeActivityModel';

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

export function sentLine(l) {
  if (!l.recipient_count) return 'Not sent';
  const when = l.last_sent_at ? `Sent ${fmtMonDay(l.last_sent_at)}` : 'Sent';
  return `${when} · ${plural(l.recipient_count, 'coach', 'coaches')}`;
}

export default function ListsCard({ userId, API_URL, cfg }) {
  const [lists, setLists] = useState(null); // null = loading
  const [err, setErr] = useState(false);
  // cfg is rebuilt every render; read it through a ref so we reload only when the athlete changes.
  const cfgRef = useRef(cfg);
  cfgRef.current = cfg;

  useEffect(() => {
    let live = true;
    setLists(null);
    setErr(false);
    axios.get(`${API_URL}/concierge/${userId}/lists`, cfgRef.current)
      .then((res) => { if (live) setLists(Array.isArray(res.data) ? res.data : []); })
      .catch(() => { if (live) setErr(true); });
    return () => { live = false; };
  }, [userId, API_URL]);

  return (
    <section className="cn-card" aria-labelledby="cn-lists-title">
      <div className="cn-card__head">
        <h2 className="cn-card__title" id="cn-lists-title">Lists</h2>
        {lists && lists.length > 0 && <span className="cn-card__sub">{plural(lists.length, 'list', 'lists')}</span>}
      </div>
      {err && <div className="cn-empty-line cn-empty-line--err">Couldn't load lists.</div>}
      {!err && lists === null && <div className="cn-empty-line">Loading…</div>}
      {!err && lists && lists.length === 0 && <div className="cn-empty-line">Not on any lists.</div>}
      {!err && lists && lists.map((l) => (
        <div key={l.id} className="cn-row cn-kv">
          <span className="cn-kv__label">
            <Link to={`/lists?list=${l.id}`}>{l.title}</Link>
            <span className="cn-kv__sub">{sentLine(l)}</span>
          </span>
          <span className={`cn-kv__value cn-tone--${l.opened_count ? 'ink' : 'muted'}`}>
            {l.recipient_count ? `${l.opened_count} opened` : ''}
          </span>
        </div>
      ))}
    </section>
  );
}
